export const REQUEST_CONTRACTS = "REQUEST_CONTRACTS";
export const REQUEST_CONTRACTS_SUCCEEDED = "REQUEST_CONTRACTS_SUCCEEDED";
export const REQUEST_CONTRACTS_FAILED = "REQUEST_CONTRACTS_FAILED";
export const REQUEST_SKILLS = "REQUEST_SKILLS";
export const REQUEST_SKILLS_SUCCEEDED = "REQUEST_SKILLS_SUCCEEDED";
export const REQUEST_SKILLS_FAILED = "REQUEST_SKILLS_FAILED";
export const CREATE_TECHNICIAN = "CREATE_TECHNICIAN";
export const CREATE_TECHNICIAN_FAILED = "CREATE_TECHNICIAN_FAILED";
export const UPDATE_TECHNICIAN = "UPDATE_TECHNICIAN";
export const UPDATE_TECHNICIAN_FAILED = "UPDATE_TECHNICIAN_FAILED";
export const DEACTIVATE_TECHNICIAN = "DEACTIVATE_TECHNICIAN";
export const IS_TECHNICIAN_ENABLED = "IS_TECHNICIAN_ENABLED";
export const SET_LABOURER_STATUS = "SET_LABOURER_STATUS";

export const requestContracts = () => {
    return {
        type: REQUEST_CONTRACTS,
    };
};

export const requestContractsSucceeded = (contracts) => {
    return {
        type: REQUEST_CONTRACTS_SUCCEEDED,
        contracts,
    };
};

export const requestContractsFailed = () => {
    return {
        type: REQUEST_CONTRACTS_FAILED,
    };
};
export const requestSkills = () => {
    return {
        type: REQUEST_SKILLS,
    };
};

export const requestSkillsSucceeded = (skills) => {
    return {
        type: REQUEST_SKILLS_SUCCEEDED,
        skills,
    };
};

export const requestSkillsFailed = () => {
    return {
        type: REQUEST_SKILLS_FAILED,
    };
};
export const createTechnician = (technician) => {
    return {
        type: CREATE_TECHNICIAN,
        technician,
    };
};
export const updateTechnician = (technician) => {
    return {
        type: UPDATE_TECHNICIAN,
        technician,
    };
};

export const createTechnicianFailed = (error) => {
    return {
        type: CREATE_TECHNICIAN_FAILED,
        error,
    };
};

export const deactivateTechnician = (technicianKeyClockId, status) => {
    return {
        type: DEACTIVATE_TECHNICIAN,
        technicianKeyClockId,
        status,
    };
};

export const isTechnicianEnabled = (technicianKeyClockId) => {
    return {
        type: IS_TECHNICIAN_ENABLED,
        technicianKeyClockId,
    };
};

export const setSelectedLabourerStatus = (status) => {
    return {
        type: SET_LABOURER_STATUS,
        status,
    };
};
